// React import
import * as React from 'react';
// Standard layout imports
import { ISubActivityModel } from 'src/Entities/Activity/Activity';
import Box from 'src/components/Box';
import { format, compareAsc } from 'date-fns';
import mapMarker from 'src/images/map_marker.png';
import Button from 'src/components/Button';
import Icon from 'src/components/Icon';
import AnimateHeight from 'react-animate-height';
import SubActivity from './subActivityItem';

interface IProps {
  subActivities: ISubActivityModel[];
}
const SubActivitiesComponent = ({ subActivities }: IProps) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const activities = React.useMemo(() => {
    return subActivities.sort((a, b) =>
      compareAsc(new Date(a.startDate), new Date(b.startDate))
    );
  }, [subActivities]);

  const mainActivity = React.useMemo(() => {
    return activities[0];
  }, [activities]);

  const remainingActivities = React.useMemo(() => {
    return activities.slice(1);
  }, [activities]);

  return (
    <Box>
      {mainActivity !== undefined && <SubActivity subActivity={mainActivity} />}
      {remainingActivities.length > 0 && (
        <>
          <AnimateHeight duration={500} height={isExpanded ? 'auto' : 0}>
            {remainingActivities.map((activity, index) => (
              <SubActivity
                subActivity={activity}
                key={`${activity.lektionId} ${index}`}
              />
            ))}
          </AnimateHeight>
          <Button
            color="light"
            className="w-full justify-center is-gray uppercase"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? 'MINIMER DELAKTIVITETER' : 'VIS FLERE DELAKTIVITETER'}
            <Icon
              name={isExpanded ? 'chevron-up' : 'chevron-down'}
              className="ml2"
            />
          </Button>
        </>
      )}
    </Box>
  );
};

export default SubActivitiesComponent;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Activityies/Activity/subActivities.component.tsx